import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Inventur } from '../../../warehouse/inventur/entities/Inventur';

@Component({
    selector: 'kiene-inventur-actice-notice-dialog',
    templateUrl: './inventur-actice-notice-dialog.component.html',
    styleUrls: ['./inventur-actice-notice-dialog.component.scss'],
})
export class InventurActiceNoticeDialogComponent implements OnInit {
    inventur: Inventur;
    constructor(
        public dialogRef: MatDialogRef<InventurActiceNoticeDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data,
    ) {}

    ngOnInit(): void {
        this.inventur = this.data.inventur;
    }
    close() {
        this.dialogRef.close(false);
    }

    save() {
        this.dialogRef.close(true);
    }
}
